//获取首页数据
export const getIndex=()=>{
    return axios.get('index/abgwPcIndex')
}

//获取分类下banner
export const getBanner=(params)=>{
    return axios.get('ad/queryAll',{params})
}

//获取导航菜单
export const getMenu = (paras)=>{
    return axios.get('index/abgwHomeMenuList',{params})
}


// 获取底部footer数据
export const getFooter = ()=>{
    return axios.get('macro/getAllMacro')
}



// 上传文件
export const uploader = ()=>{
    return axios.post('upload/upload')
}